import React, { useState } from "react";
import { loginUser } from "../api/auth";

export default function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async () => {
    try {
      setError("");

      const token = await loginUser(username, password);

      if (!token) {
        throw new Error("Invalid token received");
      }

      localStorage.setItem("token", token);

      onLogin(token); // ✅ FIXED

    } catch (err) {
      setError(
        err.response?.data?.message ||
        err.message ||
        "Login failed"
      );
    }
  };

  return (
    <div className="login-container" style={styles.container}>
      <h2>Cyber Lab Login</h2>

      <input
        type="text"
        placeholder="Username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        style={styles.input}
      />

      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        style={styles.input}
      />

      <button onClick={handleLogin} style={styles.button}>
        Login
      </button>

      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
}
const styles = {
  container: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Arial"
  },
  form: {
    display: "flex",
    flexDirection: "column",
    width: "350px",
    gap: "20px"
  },
  input: {
    padding: "10px",
    fontSize: "18px"
  },
  button: {
    padding: "20px",
     width: "40%",
    background: "#2b6cb0",
    color: "white",
    border: "none",
    cursor: "pointer",
    fontSize: "20px"
  },
  error: {
    color: "red"
  }
};
